import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {connect} from 'react-redux';
import {Form, Icon, Switch} from 'antd';
import Constants from '../../../services/Constants';
import User from '../../../services/User';
import {getCounters, getFilters} from '../../../selectors/interventionsSelector';

import SAInputSearch from '../../common/input/SAInputSearch';

import './TasksTableHeader.css';

const DEFAULT_BUTTONS = {
  interventionStatus: [
    Constants.STATUS_OPEN,
    Constants.STATUS_OPEN_48,
    Constants.STATUS_READY_FOR_APPOINTMENT,
    Constants.STATUS_ONGOING,
  ],
  type: [Constants.TYPE_PITSTOP],
};

const TasksTableHeader = ({contentUpdater, onShowArchived, onShowOnlyMine, showArchived, showOnlyMine, onListRefresh, fetchWithDefaultFilters, filters, counters}) => {

  const intl = useIntl();
  const [currentSearchValue, setCurrentSearchValue] = useState(null);

  const onResetFilter = () => {
    setCurrentSearchValue('');
    fetchWithDefaultFilters();
  }

  const onSearch = (value) => {
    contentUpdater({search: value});
  };

  const onToggleFilter = (filter, buttonGroup) => {
    const exists = filters[buttonGroup].includes(filter);
    const updatedGroup = exists ? filters[buttonGroup].filter(i => i !== filter) : [...filters[buttonGroup], filter];
    contentUpdater({[buttonGroup]: updatedGroup});
  };

  return (
    <header className="table-wrapper__header">
      <Form className="table-search">
        <div className="table-search__field">
          <label htmlFor="table-search" className="sr-only">Search in overview table</label>
          <SAInputSearch
            type="text"
            id="table-search"
            placeholder={intl.formatMessage({id: 'placeholder.search'})}
            enterButton={true}
            value={currentSearchValue}
            onSearch={onSearch}
            onChange={(event) => setCurrentSearchValue(event.target.value)}
          />
        </div>
      </Form>

      {!User.isCallCenterAgent() && (
        <div className="table-buttons">
          {Object.keys(DEFAULT_BUTTONS).map(buttonGroup =>
            DEFAULT_BUTTONS[buttonGroup].map((b, i) => (
              <div key={i} className="table-buttons__button">
                <button
                  key={b.value}
                  type="primary"
                  className={`btn ${(filters[buttonGroup] || []).includes(b.value) ? 'btn-outline-active' : 'btn-outline'}`}
                  onClick={() => onToggleFilter(b.value, buttonGroup)}
                >
                  {intl.formatMessage(b.label)}
                  &nbsp;
                  ({(counters[buttonGroup] && counters[buttonGroup][b.value]) ? counters[buttonGroup][b.value] : 0})
                </button>
              </div>
            ))
          )}
        </div>
      )}

      <div className="ant-row-flex-middle">
        <Icon type="delete" style={{fontSize: '16px', paddingRight: '10px'}} onClick={onResetFilter}/>
        <Icon type="sync" style={{fontSize: '16px', paddingRight: '10px'}} onClick={onListRefresh}/>
        <span className={"ml-4"}>
          <Switch checked={showArchived} onChange={onShowArchived}/>
          <span className={"ml-2"}>{intl.formatMessage({id: 'tasksTable.showArchived'})}</span>
        </span>
        {User.isCallCenterAgent() && (
          <span className={"ml-5"}>
            <Switch checked={showOnlyMine} onChange={onShowOnlyMine}/>
            <span className={"ml-2"}>{intl.formatMessage({id: 'tasksTable.showOnlyMine'})}</span>
          </span>
        )}
      </div>
    </header>
  );
};

const mapStateToProps = state => ({
  counters: getCounters(state),
  filters: getFilters(state),
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TasksTableHeader);
